import {Component} from '@angular/core';
import {AgRendererComponent} from 'ag-grid-angular';

@Component({
  selector: 'app-cell-renderer-move-up',
  templateUrl: './cell-renderer-move-up.component.html',
  styleUrls: ['./cell-renderer-move-up.component.less']
})

export class CellRendererMoveUpComponent implements AgRendererComponent {

  constructor() { }

  agInit() {

  }

  refresh() {
    return true;
  }

}
